module.exports = __webpack_public_path__ + "MaterialIcons-Regular.570eb83859dc23dd0eec.woff2";


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/BEX-KYC-Admin/src/assets/material-icon/MaterialIcons-Regular.woff2
// module id = ../../../../../src/assets/material-icon/MaterialIcons-Regular.woff2
// module chunks = styles